
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('BTN_Trash')]),_c('g',[_c('path',{staticClass:"cls-1",attrs:{"d":"M446.71,166.43H353.28a23.34,23.34,0,0,0-23.35,23.35v23.36H213.14a23.36,23.36,0,1,0,0,46.72H236.5V610.22a23.35,23.35,0,0,0,23.36,23.35H540.14a23.35,23.35,0,0,0,23.36-23.35V259.86h23.36a23.36,23.36,0,0,0,0-46.72H470.07V189.78A23.35,23.35,0,0,0,446.71,166.43Zm70.08,420.43H283.21v-327H516.79Z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M353.28,306.57a23.35,23.35,0,0,0-23.35,23.36V516.79a23.36,23.36,0,0,0,46.71,0V329.93A23.36,23.36,0,0,0,353.28,306.57Z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M423.36,329.93V516.79a23.36,23.36,0,0,0,46.71,0V329.93a23.36,23.36,0,1,0-46.71,0Z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M283.21,586.86H516.79v-327H283.21ZM423.36,329.93a23.36,23.36,0,1,1,46.71,0V516.79a23.36,23.36,0,0,1-46.71,0Zm-93.43,0a23.36,23.36,0,1,1,46.71,0V516.79a23.36,23.36,0,0,1-46.71,0Z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M400,0C179.09,0,0,179.09,0,400S179.09,800,400,800,800,620.91,800,400,620.91,0,400,0ZM586.86,259.86H563.5V610.22a23.35,23.35,0,0,1-23.36,23.35H259.86a23.35,23.35,0,0,1-23.36-23.35V259.86H213.14a23.36,23.36,0,1,1,0-46.72H329.93V189.78a23.35,23.35,0,0,1,23.36-23.35h93.42a23.35,23.35,0,0,1,23.36,23.35v23.36H586.86a23.36,23.36,0,0,1,0,46.72Z"}})])])
          )
        }
      }
    